import { ref } from 'vue';
import { importsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

interface ImportData {
    import_id: string;
    file_name: string;
}

export function useGroupImportSubmit(teamId: number, buildRedirectUrl: (data: ImportData) => string) {
    const toasted = useToasted();
    const file = ref<File | null>(null);
    const submitting = ref(false);

    const selectedFile = (event: File) => {
        file.value = event;
    };

    const submit = async () => {
        if (submitting.value || !file.value) {
            return;
        }
        submitting.value = true;

        try {
            const { data } = await importsClient.generateGroupsImportUploadUrl(teamId, file.value.name);

            if (!data?.upload_url) {
                throw new Error('Could not parse the upload url');
            }

            await importsClient.importGroupsCsvFile(data.upload_url, file.value);

            window.location.assign(
                buildRedirectUrl({
                    import_id: data.import_id,
                    file_name: file.value.name,
                })
            );
        } catch (error) {
            console.error(error);
            toasted.global.platform_error();
        } finally {
            submitting.value = false;
        }
    };

    return { file, submitting, selectedFile, submit };
}
